(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["complete-the-look"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.complete-look').forEach(function (wrapper) {
    function getRowData(row) {
      var checkbox = row.querySelector('[data-look-checkbox]');
      var selectEl = row.querySelector('[data-look-select]');
      var priceEl = row.querySelector('[data-look-price]');
      var variantId, price;

      if (selectEl.tagName === 'SELECT') {
        var opt = selectEl.options[selectEl.selectedIndex];
        variantId = opt.value;
        price = parseFloat(opt.getAttribute('data-price'));
      } else {
        variantId = selectEl.getAttribute('data-variant-id');
        price = parseFloat(selectEl.getAttribute('data-price'));
      }

      return { checkbox: checkbox, variantId: variantId, price: price, priceEl: priceEl };
    }

    function formatMoney(cents) {
      return '$' + Math.round(cents / 100).toLocaleString('es-CO');
    }

    function updateTotal() {
      var total = 0;
      wrapper.querySelectorAll('[data-product-row]').forEach(function (row) {
        var data = getRowData(row);
        data.priceEl.textContent = formatMoney(data.price);
        if (data.checkbox.checked) {
          total += data.price;
        }
      });
      wrapper.querySelector('[data-look-total]').textContent = formatMoney(total);
    }

    wrapper.querySelectorAll('[data-look-select]').forEach(function (el) {
      el.addEventListener('change', updateTotal);
    });

    wrapper.querySelectorAll('[data-look-checkbox]').forEach(function (el) {
      el.addEventListener('change', updateTotal);
    });

    updateTotal();

    var addButton = wrapper.querySelector('[data-look-add-button]');
    var messageEl = wrapper.querySelector('[data-look-message]');

    addButton.addEventListener('click', function () {
      var items = [];
      wrapper.querySelectorAll('[data-product-row]').forEach(function (row) {
        var data = getRowData(row);
        if (data.checkbox.checked) {
          items.push({ id: parseInt(data.variantId, 10), quantity: 1 });
        }
      });

      if (items.length === 0) {
        messageEl.textContent = 'Selecciona al menos un producto.';
        return;
      }

      addButton.disabled = true;
      addButton.textContent = 'Agregando...';
      messageEl.textContent = '';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('No se pudo agregar al carrito');
          return response.json();
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function () {
          addButton.disabled = false;
          addButton.textContent = 'Añadir a la cesta';
          messageEl.textContent = 'Ocurrió un error, intenta de nuevo.';
        });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-tabs"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var tab = e.target.closest('.product-tabs__tab');
    if (!tab) return;

    var wrapper = tab.closest('.product-tabs');
    var index = tab.getAttribute('data-tab');

    wrapper.querySelectorAll('.product-tabs__tab').forEach(function (t) {
      var isActive = t.getAttribute('data-tab') === index;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    wrapper.querySelectorAll('.product-tabs__panel').forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-panel') === index);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
